import { render, staticRenderFns } from "./JSONTemplateTransactionGroupEditor.vue?vue&type=template&id=6dac0aee&scoped=true"
import script from "./JSONTemplateTransactionGroupEditor.vue?vue&type=script&lang=js"
export * from "./JSONTemplateTransactionGroupEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dac0aee",
  null
  
)

export default component.exports